module.exports = __webpack_public_path__ + "img/2BB.0d42b4f1.jpg";